//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["object_to_log"],"LogConcurrent",{},1,0],[["object_to_unlog"],"UnlogConcurrent",{},1,0],[["num_objects","objects"],"GetConcurrentObjects",{},0,0],[[],"ExpandConcurrent",{},0,0],[[],"ClearConcurrent",{},0,0],[["nxObject","nViolations"],"GetObjectViolations",{R_:{violations:"Routing.DesignRuleViolation[]"}},1,0]],[]];
SPLM.Routing.DesignRuleManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.DesignRuleManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;